import { FC } from 'react';
import { Tr } from '@utils';
import { Button, Link, Stack } from '@mui/material';
import { GuardedRender, PortalPageTitle } from '@components/portal/common';
import { ITrainingProps, Training } from '@components/portal/help';

const paddingX = 9;
const VIDEO_LINK = 'https://www.loom.com/share/11f129063d3247c4a9ba67ea449a6af2';
const DOCS_LINK = 'https://docs.google.com/presentation/d/1dA9tm1GzsF3iHmowvsiajJM2dRB5iFwGI9P9e75auWY';

const DEALER_TRAININGS: ITrainingProps[] = [
	{
		header: <Tr.Portal path="help.trainings.dealer.new-client" />,
		url: 'https://app.storylane.io/share/apprvcocy63s'
	},
	{
		header: <Tr.Portal path="help.trainings.dealer.start-analysis" />,
		url: 'https://app.storylane.io/share/cuzjvjjqfxi3'
	},
	{
		header: <Tr.Portal path="help.trainings.dealer.select-ev" />,
		url: 'https://app.storylane.io/share/dqayekm4ekpb'
	}
];

const MANAGER_TRAININGS: ITrainingProps[] = [
	{
		header: <Tr.Portal path="help.trainings.manager.account-create" />,
		url: 'https://app.storylane.io/share/ldsllxujkarb'
	},
	{
		header: <Tr.Portal path="help.trainings.manager.add-website" />,
		url: 'https://app.storylane.io/share/cuzjvjjqfxi3'
	},
	{
		header: <Tr.Portal path="help.trainings.manager.add-facility-manager" />,
		url: 'https://app.storylane.io/share/dqayekm4ekpb'
	}
];

export const Help: FC = () => {
	return (
		<Stack direction="column" spacing={3} sx={{ height: 1.0, maxHeight: 1.0, paddingY: 5, boxSizing: 'border-box' }}>
			<PortalPageTitle paddingX={paddingX} title={<Tr.Portal path="help.title" />} subtitle={<Tr.Portal path="help.subtitle" />}>
				<Stack direction="row" spacing={2}>
					<Button
						variant="contained"
						fullWidth
						size="small"
						LinkComponent={Link}
						href={VIDEO_LINK}
						target="_blank"
						sx={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
					>
						<Tr.Portal path="help.video-action-text" />
					</Button>
					<Button
						variant="contained"
						fullWidth
						size="small"
						LinkComponent={Link}
						href={DOCS_LINK}
						target="_blank"
						sx={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
					>
						<Tr.Portal path="help.docs-action-text" />
					</Button>
				</Stack>
			</PortalPageTitle>
			<Stack direction="column" spacing={6} sx={{ flexGrow: 1, overflow: 'auto', paddingX }}>
				<GuardedRender canRender={(user) => user.isSeller()}>
					{DEALER_TRAININGS.map((training, index) => (
						<Training key={`training-${index}`} {...training} index={index + 1} />
					))}
				</GuardedRender>
				<GuardedRender canRender={(user) => user.isManager()}>
					{MANAGER_TRAININGS.map((training, index) => (
						<Training key={`training-${index}`} {...training} index={index + 1} />
					))}
				</GuardedRender>
			</Stack>
		</Stack>
	);
};
